import { useTranslation } from 'react-i18next'

import type { VersionRevision } from '../VersionListItem/VersionListItem.types'

const useVersionListItemAction = ({
    type,
    authors = [],
    statusPublishedChanged,
    changedFields = [],
}: VersionRevision) => {
    const { t } = useTranslation()

    const authorsString = (authors || [])
        .map((author) => author?.name || '')
        .join(', ')

    let actionString = ''
    const isDraft = statusPublishedChanged === 'draft'
    const isArchived = statusPublishedChanged === 'archived'
    const isPublished = statusPublishedChanged === 'published'

    switch (type) {
        case 'create':
            if (isDraft) {
                actionString = t('version.action.created-draft')
            } else {
                actionString = t('version.action.created')
            }
            break
        case 'update': {
            const changedFieldsLabels = changedFields
                .filter((field) => !(isPublished && field === 'timePublished'))
                .map((field) => t(`version.property.${field}`))
                .join(', ')

            if (isArchived) {
                actionString = t('version.action.archived')
            } else {
                if (changedFieldsLabels.length > 0) {
                    actionString = `${t('version.action.edited')} ${changedFieldsLabels}`

                    if (isPublished) {
                        actionString += ` ${t('version.action.and-published')}`
                    }
                } else if (isPublished) {
                    actionString = t('version.action.published')
                } else {
                    actionString = t('version.action.edited')
                }
            }
            break
        }
    }

    return `${authorsString} ${actionString}`
}

export default useVersionListItemAction
